export default {
    placeholder: 'Please choose…',
    searchPlaceholder: 'Search…',
    emptyText: 'No results',
};
